import { Card, Stack, TextLink, rem } from "@manulife/mux";
import LineChart from "./lineChart";
import { NormalText, NormalText14, ChartIndexLabel, GraphLine, GraphLineBorder, NormalTextW400 } from "../../assets/appStyledComponents";
import { formatAmount } from "../../services/helpers/commonHelpers";
import NumberConstants from "../../assets/appStyledComponents/numberConstant.json";
import ResultLables from "../../assets/resultLabels.json";
import NewPurchaseTabText from "../../assets/newPurchaseTabText.json";
import RenewalTabText from "../../assets/renewalTabText.json"; 

function RtgChartTabContent({
  chartData,
  validatedData,
  selectedLang,
  onTableVersionClick,
  onUnderwritingRiskClick,
  onAssumptionsDisclaimersClick,
  isRenewal = false
}) {
  const { num56, num16, num20, num2 } = NumberConstants;

  const tabText = isRenewal ? RenewalTabText : NewPurchaseTabText;

  return (
    <>
      <Card.Content>
        <NormalText>{tabText.line1[selectedLang]}</NormalText>
        <NormalText14>{tabText.line2[selectedLang]}</NormalText14>

        <LineChart
          chartData={chartData}
          validatedData={validatedData}
          selectedLang={selectedLang}
        />
      </Card.Content>

      <Card.Separator />

      <Card.Content>
        <TextLink
          to=""
          aria-label={ResultLables.viewTableVersion[selectedLang]}
          onClick={onTableVersionClick}
        >
          {ResultLables.viewTableVersion[selectedLang]}
        </TextLink>
      </Card.Content>

      <Card.Separator />

      <Card.Content>
        <ChartIndexLabel>
          {ResultLables.totalPremium65[selectedLang].label}
        </ChartIndexLabel>
        <Stack justify="space-around" style={{ flexGrow: 1, paddingBottom: rem(num20) }}>
          {/* T10 row */}
          <Stack direction="row" align="center" gapX={rem(num56)} style={{ width: '100%' }}>
            <Stack direction="row" align="center" gapX={rem(num16)}>
              <GraphLine style={{ background: "#018513" }} />
              <NormalTextW400 style={{ margin: 0 }}>T10</NormalTextW400>
            </Stack>
            <NormalTextW400>
              {formatAmount(chartData?.scalar.find(ele => ele.coverageProduct === "Term10")?.value?.toFixed(num2) || 0, selectedLang)}
            </NormalTextW400>
          </Stack>

          {/* T20 row */}
          <Stack direction="row" align="center" gapX={rem(num56)} style={{ width: '100%' }}>
            <Stack direction="row" align="center" gapX={rem(num16)}>
              <GraphLineBorder style={{ borderStyle: "dashed", borderColor: "#D93E00" }} />
              <NormalTextW400 style={{ margin: 0 }}>T20</NormalTextW400>
            </Stack>
            <NormalTextW400>
              {formatAmount(chartData?.scalar.find(ele => ele.coverageProduct === "Term20")?.value?.toFixed(num2) || 0, selectedLang)}
            </NormalTextW400>
          </Stack>

          {/* T65 row */}
          <Stack direction="row" align="center" gapX={rem(num56)} style={{ width: '100%' }}>
            <Stack direction="row" align="center" gapX={rem(num16)}>
              <GraphLineBorder style={{ borderStyle: "dotted", borderColor: "#0273B5" }} />
              <NormalTextW400 style={{ margin: 0 }}>T65</NormalTextW400>
            </Stack>
            <NormalTextW400>
              {formatAmount(chartData?.scalar.find(ele => ele.coverageProduct === "Term65")?.value?.toFixed(num2) || 0, selectedLang)}
            </NormalTextW400>
          </Stack>
        </Stack>

        <Stack direction="row">
            {isRenewal ? ( 
                <TextLink to="" onClick={onAssumptionsDisclaimersClick}>
                    {ResultLables.assumptionsAndDisclaimers[selectedLang].label}
                </TextLink>
                ) : ( 
                <>
                    <TextLink to="" onClick={onUnderwritingRiskClick}>
                        {ResultLables.underwritingRisk[selectedLang].label}
                    </TextLink>
                    <TextLink to="" onClick={onAssumptionsDisclaimersClick}>
                        {ResultLables.assumptionsAndDisclaimers[selectedLang].label}
                    </TextLink>
                </>
                )
            }
        </Stack>
      </Card.Content>
    </>
  );
}

export default RtgChartTabContent;
